import { FormValidationRule } from "../../forms/types";

const isCountryCodeSet: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (v) {
        if (!v[1]) {
            valid = false;
            message = "Please select a region.";
        }
    }
    return [valid, message];
};

export default isCountryCodeSet;
